import React, { Component } from "react";
import { Table, Segment } from "semantic-ui-react";
import { setDateFormat } from "../../../../Global/CustomFunctions";

class EmployeeWorkHistory extends Component {
  renderEmployeeWorkHistory(works) {
    if (works && works.length > 0) {
      return works.map(emp => {
        return (
          <Table.Row key={emp.Id}>
            <Table.Cell>
              {emp.Organisation}
            </Table.Cell>
            <Table.Cell>
              {emp.Role}
            </Table.Cell>
            <Table.Cell>
              {setDateFormat(emp.JoiningDate).format("LL")}
            </Table.Cell>
            <Table.Cell>
              {setDateFormat(emp.LeavingDate).format("LL")}
            </Table.Cell>
          </Table.Row>
        );
      });
    }
  }

  render() {
    let { works } = this.props;
    return (
      <Segment.Group className="BasicInfoCnt">
        <Segment basic>
          <h1 className="textStyleHeading">Work History</h1>
          <Table singleLine>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Organisation</Table.HeaderCell>
                <Table.HeaderCell>Role</Table.HeaderCell>
                <Table.HeaderCell>Joining Date</Table.HeaderCell>
                <Table.HeaderCell>Leaving Date</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {this.renderEmployeeWorkHistory(works)}
            </Table.Body>
          </Table>
        </Segment>
      </Segment.Group>
    );
  }
}

export default EmployeeWorkHistory;
